import * as Types from '@saas/interfaces/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddLogMutationVariables = Types.Exact<{
  input: Types.LogInputDef;
}>;


export type AddLogMutation = (
  { __typename?: 'Mutation' }
  & Pick<Types.Mutation, 'logMutationCreate'>
);


export const AddLogDocument = gql`
    mutation addLog($input: LogInputDef!) {
  logMutationCreate(input: $input)
}
    `;
export type AddLogMutationFn = Apollo.MutationFunction<AddLogMutation, AddLogMutationVariables>;

/**
 * __useAddLogMutation__
 *
 * To run a mutation, you first call `useAddLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLogMutation, { data, loading, error }] = useAddLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLogMutation(baseOptions?: Apollo.MutationHookOptions<AddLogMutation, AddLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLogMutation, AddLogMutationVariables>(AddLogDocument, options);
      }
export type AddLogMutationHookResult = ReturnType<typeof useAddLogMutation>;
export type AddLogMutationResult = Apollo.MutationResult<AddLogMutation>;
export type AddLogMutationOptions = Apollo.BaseMutationOptions<AddLogMutation, AddLogMutationVariables>;